import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { TenantSettings } from "@types";
import { getKeycloakRealm } from "@/components/helpers";

export const useGetTenantSettings = (enabled: boolean = false) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const tenantRealm = getKeycloakRealm;

  const getTenantSettings = async (): Promise<TenantSettings> => {
    try {
      const { data } = await axios.get<TenantSettings>("/api/tenantsetting");
      return data;
    } catch (error) {
      throw new Error(t("messages.error.getTenantSettings"));
    }
  };

  return useQuery({
    queryKey: ["tenantSettings", tenantRealm],
    queryFn: getTenantSettings,
    enabled: enabled && Boolean(tenantRealm),
    staleTime: Infinity,
  });
};
